import { memo, type RefObject } from 'react';

import { Portal } from '@air/primitive-portal';

type AnnotationTooltipProps = {
  innerRef: RefObject<HTMLDivElement>;
  shouldDisplay?: boolean;
  text: string;
};
export const AnnotationTooltip = memo(({ innerRef, shouldDisplay, text }: AnnotationTooltipProps) => {
  return (
    <Portal>
      {shouldDisplay && (
        <div className="fixed z-1 rounded-4 bg-black/80 px-2 py-1 transition-opacity" ref={innerRef}>
          <div className="font-semibold text-12 text-white">{text}</div>
        </div>
      )}
    </Portal>
  );
});

AnnotationTooltip.displayName = 'AnnotationTooltip';
